// middleware/order-header.global.ts

import type { Order } from '~/types/order' 
export default defineNuxtRouteMiddleware(async (to) => {
  const orderHeader = useOrderHeader()
  const isInOrderFlow = to.path.includes('modules/data-entry/orders')

  // Si sale del flujo, limpiar el estado
  if (!isInOrderFlow) {
    if (orderHeader.value) orderHeader.value = null
    return
  }

  // Si está dentro del flujo pero no hay data (entró directo por URL), rehidratar
  const orderId = to.params.orderId as string // ajusta según tu route param

  if (!orderHeader.value || orderHeader.value.id !== Number(orderId)) {
    try {
      
      const { data } = await useApiFetchObject<Order>(
        `/productionBatch/${orderId}`
      )
      const response = data.value?.data as Order;
      const val = await $fetch(`/api/productionBatch/${orderId}`) as any // ajusta a tu endpoint real

      orderHeader.value = {
        id: response.id,
        batchNumber: response.batchNumber,
        customerOrder: response.customerOrder,
        salesOrder: response.salesOrder,
        operatorName: `${response.user?.firstName} ${response.user?.lastName}`,
        productionDate: formatearFechaHora(response.productionDate),
        status : response.status,
        notes: response.notes
      }
    } catch (e) {
      console.error('Error fetching order header', e)
      // opcional: redirigir a una página de error o lista de orders
    }
  }
})